import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { VehiclesModel } from '../../../vehicles/vehicles.model';
import { GridOptions } from 'ag-grid';
import { EventEmitter } from '@angular/common/src/facade/async';
import { VehiclesService } from '../../../vehicles/vehicles.service';
import { OnDemandDriversService } from '../../on-demand-drivers.service';
import { T2CardComponent } from '../../../../trip2-theme/components/t2-card/t2-card.component';
import { T2LoadingService } from '../../../../trip2-theme/components/t2-loading/t2-loading.service';
import { constant } from '../../../../app.constants';
import { BooleanCheckComponent } from '../../../A2-utils/grid-components/boolean-check/boolean-check.component';
import { LicensesService } from '../../../../services/licenses.service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { Subscription } from 'rxjs';

declare var $: any;

@Component({
  selector: 'app-on-demand-drivers-vehicles',
  templateUrl: './vehicles.component.html',
  styleUrls: ['./vehicles.component.scss']
})
export class VehiclesComponent implements OnInit, OnChanges, OnDestroy {

  /**
   * Vehicle selected
   * @type {VehiclesModel}
   */
  public selectedVehicle: VehiclesModel = new VehiclesModel();

  private images: any[] = new Array();

  /**
   * Grid
   */
  private inspectionsGrid: GridOptions;
  private licensesGrid: GridOptions;
  private inactiveLicense = false;

  /**
   * vehicles array
   */
  private vehicles: any[];
  private selectedLicenseType: number;
  private licenseTypes: any[];
  public maskDate = constant.MASKS.DATES.DDMMYYYY;
  private thePattern = '';

  public tabFiles = 1;

  /**
   * Inputs y Outputs
   */
  @Input() selected: number;
  @Output() notify: EventEmitter < boolean > = new EventEmitter < boolean > ();
  @Output() cancel: EventEmitter < boolean > = new EventEmitter < boolean > ();

  @ViewChild('licenseBtn') licenseBtn: ElementRef;
  @ViewChild('popLicenseContent') popLicense: T2CardComponent;

  /**
   * Variables for upload document (License)
   */
  private isMsgVisible = false;
  private b64File: string;
  private strSubstr: string;
  private str: string;
  private base64File: string;
  private description: string = null;
  private documentFile: any;
  private fileName: string;
  private mimeType: string;
  private readHistoryFilesValue: any;
  private uploadHistoryEvent: any;
  private showLoading = false;
  private errorMessage: string = null;
  public isActive = false;

  /**
   * @name Constructor
   * @param vehicleService
   * @param onDemandService
   * @param renderer
   */

  deg = 0;
  public suscription: Subscription[] = [];

  constructor(
    protected vehicleService: VehiclesService,
    protected onDemandService: OnDemandDriversService,
    protected _loading: T2LoadingService,
    private _serviceLicensesService: LicensesService,
    private sweetAlertHelper: SweetAlertHelper,
  ) {
    this.inspectionsGrid = < GridOptions > {};
    this.configureGrid();
    this.licensesGrid = < GridOptions > {};
    this.configureLicenseGrid();
  }

  ngOnInit() {
    this.loadVehiclesForSelectedDriver();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const selectedChange = changes['selected'];

    if (
      selectedChange &&
      !selectedChange.isFirstChange() &&
      selectedChange.currentValue &&
      selectedChange.currentValue !== selectedChange.previousValue
    ) {
      this.loadVehiclesForSelectedDriver();
    }
  }

  private loadVehiclesForSelectedDriver(): void {
    if (this.selected !== 0) {
      this.onDemandService.getDriverByID(this.selected).subscribe(
        data => {
          this.getLicenseTypes(data.companyid);
        }
      );
    }

    this.selectedVehicle = new VehiclesModel();
    if (this.licensesGrid && this.licensesGrid.api) {
      this.licensesGrid.api.setRowData([]);
    }
    this.getAllVehicles();
  }


  /**
   * @name getAllVehicles
   * @description Retrieve all vehicles data from server
   */
  private getAllVehicles() {
    this.vehicleService
    .getVehiclesByDriver(this.selected, true)
    .subscribe(
      data => this.loadData(data),
      (error) => {
        this.sweetAlertHelper.captureException(error);
      }
    );
  }

  /**
   * @name getAllLicenses
   * @description Retrieve all licenses data from server
   */
  private getAllLicenses() {
    this.onDemandService
    .getVehicleLicenses(this.selected, this.selectedVehicle.vehicleid, this.inactiveLicense)
    .subscribe(
      data => {
        if (this.licensesGrid) {
          if (this.licensesGrid.api) {
            this.licensesGrid.api.setRowData(data);
          }
        }
      }
    );
  }

  /**
   * @name loadData
   * @description Prepare the data retrieved from server
   * @param data
   */
  private loadData(data) {
    this.vehicles = data;
    if (data && data.length > 0) {
      this.selectedVehicle = data[0];
      this.selectedVehicle.policyexpirydate = data[0].policyexpirydateformatted;
      this.selectedVehicle.registrationexpdate = data[0].registrationexpdateformatted;
      this.getPhotos(data[0].vehicleid);
      this.isActive = data[0].isactive;
    }
  }

  /**
   * @name cancelCreateEdit
   * @description Close the form panel
   */
  cancelCreateEdit() {
    this.cancel.emit(true);
  }

  /**
   * @name sendNotify
   * @description send notification to parent component
   * @param data
   */
  sendNotify(data: any) {
    this.notify.emit(data);
  }

  /**
   * @name saveAction
   * @description Update vehicle data into server
   */
  saveAction() {
    if (this.selected !== 0) {
      this._loading.show();
      this.selectedVehicle.policyexpirydateformatted = this.selectedVehicle.policyexpirydate;
      this.selectedVehicle.registrationexpdateformatted = this.selectedVehicle.registrationexpdate;
      this.vehicleService
      .putData(this.selectedVehicle)
      .finally(() => this._loading.hiden())
      .subscribe(
        res => {
          // this.sendNotify(res);
          this.sweetAlertHelper.createCustomAlert({
            title: res.message,
            text: 'clicked!',
            type:'success',
          });
        },
        eror => {
          // this.sendNotify(eror);
          this.selectedVehicle.prescheduled = false;
          this.sweetAlertHelper.createCustomAlert({
            title:eror.message,
            text:'clicked',
            type: 'error',
          });
        }
      );
    }
  }

  /**
   * @name configureGrid
   * @description The inspections grid configuration
   */
  private configureGrid() {
    const resize = this.inspectionsGrid;
    this.inspectionsGrid.columnDefs = [{
        headerName: 'Inspected On',
        field: 'inspectedonformatted',
        colId: 'inspectedon'
      },
      {
        headerName: 'Inspected By',
        field: 'inspectedby',
        colId: 'inspectedby'
      },
      {
        headerName: 'Status',
        field: 'isactive',
        cellRendererFramework: BooleanCheckComponent,
        colId: 'status'
      },
      {
        headerName: 'image',
        field: 'attachment',
        // cellRendererFramework: ViewAttachment,
        colId: 'attachment'
      }
    ];

    this.inspectionsGrid.onGridReady = function () {
      resize.api.sizeColumnsToFit();
    };
  }

  /**
   * @name configureLicenseGrid
   * @description The licenses grid configuration
   */
  private configureLicenseGrid() {
    const resize = this.licensesGrid;
    this.licensesGrid.columnDefs = [{
        headerName: 'Added On',
        field: 'addedonformatted',
        colId: 'addedonformatted'
      },
      {
        headerName: 'Document',
        field: 'typelicenseprovider.typelicense.description',
        colId: 'description'
      },
      {
        headerName: 'Expiration',
        field: 'expirationformatted',
        colId: 'expirationformatted'
      },
      {
        headerName: 'Status',
        field: 'status',
        colId: 'status'
      },
      {
        headerName: 'Image',
        field: 'attachment',
        // cellRendererFramework: ViewAttachment,
        colId: 'attachment'
      }
    ];

    this.licensesGrid.onGridReady = function () {
      resize.api.sizeColumnsToFit();
    };
  }

  /**
   * @name onChange
   * @description combo vehicles on change event
   * @param event
   */
  public onChange(event) {
    this.isActive = false;
    if (event['isactive']) {
      this.isActive = true;
    }
    this.selectedVehicle = event;
    this.selectedVehicle.policyexpirydate = event.policyexpirydateformatted;
    this.selectedVehicle.registrationexpdate = event.registrationexpdateformatted;
    this.selectedVehicle.make = event.make;
    this.selectedVehicle.model = event.model;
    this.selectedVehicle.year = event.year;
    this.getPhotos(event.vehicleid);
  }

  /**
   * @name getPhotos
   * @description Retrieve photos data from server
   * @param vehicleid
   */
  private getPhotos(vehicleid) {
    if (vehicleid) {
      this._loading.show();
      this.vehicleService
        .getPhotoByVehicleId(vehicleid)
        .finally(() => this._loading.hiden())
        .subscribe((data) => this.filterImages(data.vehiclephotos));
    }
  }

  /**
   * @name filterImages
   * @description Filter the required photos
   * @param images
   */
  private filterImages(images: any[]) {
    this.images = images.filter(
      com => com.isrequired === true
    );
  }


  /**
   * @name getInspections
   * @description Retrieve inspections data from server
   */
  private getInspections() {
    this.vehicleService
    .getInspections(this.selectedVehicle.vehicleid)
    .subscribe(
      data => this.loadInspections(data)
    );
  }

  /**
   * @name loadInspections
   * @description Prepare the inspections data retrieved from server
   * @param data
   */
  private loadInspections(data) {
    if (this.inspectionsGrid) {
      if (this.inspectionsGrid.api) {
        this.inspectionsGrid.api.setRowData(data);
      }
    }
  }

  /**
   * @name onPanelChange
   * @description Event when the accordion change the status
   * @param event
   */
  public onPanelChange(event) {
    if (event.panelId === '2' && event.nextState) {
      this.getInspections();
    } else if (event.panelId === '3' && event.nextState) {
      this.getAllLicenses();
    }
  }

  /**
   * @name onSaveInspection
   * @description Retrieve inspections data from server after Inspections has been created
   */
  public onSaveInspection() {
    this.getInspections();
  }

  /**
   * @name showExpired
   * @description Show the expired licenses
   */
  public showExpired() {
    this.getAllLicenses();
  }

  /**
   * @name uploadHistoryFile
   * @description METHODS TO UPLOAD DOCUMENT
   */
  public uploadHistoryFile(event) {
    if (event.target.files.length) {
      this.isMsgVisible = false;
      this.readHistoryFilesValue = event.target.files[0];
      this.uploadHistoryEvent = event;
      this.readFiles(this.readHistoryFilesValue);
      this.fileName = this.readHistoryFilesValue.name;
      this.mimeType = this.readHistoryFilesValue.type;
      this.errorMessage = null;
    } else {
      this.fileName = '';
    }
  }

  /**
   * @name readFiles
   * @description Read file for convert to base64
   * @param files
   */
  private readFiles(files) {
    const reader = new FileReader();
    this.readFile(files, reader, (result) => {
      // this.historyFileSelected=result;
    });
  }

  /**
   * @name readFile
   * @description Read file for convert to base64
   * @param file
   * @param reader
   * @param callback
   */
  private readFile(file, reader, callback) {
    if (file) {
      reader.onload = () => {
        callback(reader.result);
        this.base64File = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  /**
   * ********************** Methods for move view *********************************
   */

  /**
   * @name hideLicensePopover
   * @description Hide the popover view for add license
   */
  private hideLicensePopover() {
    this.popLicense.close();
  }

  /**
   * @name resetView
   * @description Reset Popover View
   */
  private resetView() {
    this.base64File = null;
    this.description = '';
    this.fileName = '';
    this.errorMessage = null;
    this.documentFile = {};
  }

  /**
   * @name getLicenseTypes
   * @description Retrieve license types data
   */
  private getLicenseTypes(ProviderId: number) {
    this.getTypeLicenseProvider(ProviderId);
    /*
    Comento esto porque se cambio el servicio, el metodo ahora es getTypeLicenseProvider lo llamo aqui para
    evitar problemas de llamado y permitir validaciones futuras.
    this.onDemandService
    .getVLicenseTypes()
    .subscribe(
      data => this.licenseTypes = data
    );*/
  }

  getTypeLicenseProvider(ProviderId: number) {
    // this.data.companyid
    this._serviceLicensesService.getTypeLicenseVehicleProviderId(ProviderId).subscribe(
      data => {
        this.licenseTypes = data;
      }
    );
  }

  /**
   * @name saveLicense
   * @description call method in service for save the license into bd
   */
  public saveLicense() {
    if (this.base64File != null && this.base64File && this.description != null && this.description !== '') {
      this.errorMessage = null;
      this.showLoading = true;
      this.popLicense.viewProgressBar(true);

      this.isMsgVisible = false;
      this.str = this.base64File;
      this.strSubstr = this.str.substr(0, this.str.lastIndexOf(','));
      this.b64File = this.base64File.replace(this.strSubstr + ',', '');
      this.documentFile = {
        'trip2driverid': this.selected,
        'TypeLicenseProviderId': this.selectedLicenseType,
        'Expiration': this.description,
        'imagebase64': this.b64File,
        'vehicleid': this.selectedVehicle.vehicleid,
        'mimetype': this.mimeType
      };

      this.onDemandService
      .addLicense(this.documentFile)
      .finally(() => {
        this.popLicense.viewProgressBar(true);
        this.showLoading = false;
      })
      .subscribe(
        data => {
          this.getAllLicenses();
          this.resetView();
          this.popLicense.close();
        },
        err => {
          this.errorMessage = 'Error, please try later';
        }
      );
    } else {
      this.isMsgVisible = true;
      this.errorMessage = 'File is required';
    }
  }

  /**
   * @name onBlurDate
   * @description show the mask in the date field
   */
  public onBlurDate() {
    this.thePattern = '^((0?[1-9]|1[012])[- -.](0?[1-9]|[12][0-9]|3[01])[- -.](19|20)?[0-9]{2})*$';
  }

  onOpenDocument($event) {
    window.open($event.data.attachment);
  }

  onRotate(option: number) {
    if (option === 1) {
      this.deg = this.deg - 90;
    } else {
      this.deg = this.deg + 90;
    }
    $("#rotate").css({
      "-webkit-transform": "rotate(" + this.deg + "deg)",
      "-moz-transform": "rotate(" + this.deg + "deg)",
      transform: "rotate(" + this.deg + "deg)"
    });
  }

  vehicleChange(event: any) {
    if (event) {
      this.selectedVehicle.make = event.make;
      this.selectedVehicle.model = event.model;
      this.selectedVehicle.year = event.year;
    }
  }

  changeActive() {
    if (this.selectedVehicle && this.selectedVehicle.vehicleid) {
      this.suscription.push(
        this.onDemandService
          .changeActive(this.selectedVehicle.vehicleid)
          .subscribe({
            next: (resp) => {
              this.sweetAlertHelper.createCustomAlert({
                title: resp.message,
                type: 'success',
                timer: 1000,
                showConfirmButton: false,
              });
              this.isActive = this.selectedVehicle.isactive;
            },
            error: (err) => {
              this.sweetAlertHelper.captureException(err);
            },
          })
      );
    }
  }

  getIsactive(isActive: boolean): string {
    return isActive ? 'Active' : 'Inactive';
  }

  ngOnDestroy(): void {
    this.suscription.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/on-demand-drivers/components/vehicles/vehicles.component.ts